// Boots behavior shared by every authenticated and unauthenticated page.
import './core/errors'
import './core/htmx'
import './core/toasts'
import { initializeAutoSubmitForms, initializeConfirmForms } from './common/forms'
import { initializeAiImportSettings } from './common/ai-import-settings'
import { initializeTimezonePickers } from './common/timezone-picker'
import { Log } from './core/logger'

Log.info('Initialize shared page controls', () => {
  initializeAutoSubmitForms()
  initializeConfirmForms()
  initializeAiImportSettings()
  initializeTimezonePickers()
})

document.body.addEventListener('htmx:load', (event) => {
  /**
   * Limits reinitialization to the subtree htmx just inserted.
   */
  const root = (event as CustomEvent<{ elt?: Element }>).detail?.elt
  const scope = root ?? document

  Log.info('Initialize controls in updated page content', () => {
    initializeAutoSubmitForms(scope)
    initializeConfirmForms(scope)
    initializeAiImportSettings(scope)
    initializeTimezonePickers(scope)
  })
})
